import React from "react";
import { compose } from "redux";

import AppStateHOC from "../lib/app-state-hoc.jsx";
import GUI from "../containers/gui.jsx";
import HashParserHOC from "../lib/hash-parser-hoc.jsx";
import { AntdStatic } from "../utils/antd-static.js";

const onClickLogo = () => {};

const WrappedGui = compose(AppStateHOC, HashParserHOC)(GUI);

const GuiComponent = (props) => {
    return (
        <>
            <AntdStatic />
            <WrappedGui
                canEditTitle
                backpackVisible
                showComingSoon
                canSave={false}
                onClickLogo={onClickLogo}
                {...props}
            />
        </>
    );
};

export default GuiComponent;
